// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"532":"styles","2143":"app"}[chunkId] || chunkId) + "." + {"532":"e0382baa495f4891636a","2143":"478392804098f413b1bb","5081":"6cf3704e36fa2ed99a30"}[chunkId] + ".css";
};